export const FIXED_VIEWPORT = {
  name: 'viewport',
  content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, viewport-fit=cover',
};
